import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { useCurrentUser, useLogout } from "@crm/api";
import { cn } from "@crm/utils";
import { ClipboardList, LogOut } from "lucide-react";
import { LocationToggle } from "../LocationToggle";

const navigation = [{ name: "My Incidents", href: "/", icon: ClipboardList }];

export function AppLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { data: user } = useCurrentUser();
  const logoutMutation = useLogout();

  const handleLogout = () => {
    logoutMutation.mutate(undefined, {
      onSettled: () => {
        navigate("/login");
      },
    });
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Top header bar */}
      <header className="sticky top-0 z-50 flex h-16 items-center justify-between border-b border-border bg-card px-6">
        <div className="flex items-center gap-8">
          <span className="text-lg font-semibold text-foreground">
            CRM Worker
          </span>
          <nav className="flex items-center gap-1">
            {navigation.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={cn(
                    "flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors",
                    isActive
                      ? "bg-primary text-primary-foreground"
                      : "text-muted-foreground hover:bg-muted hover:text-foreground"
                  )}
                >
                  <item.icon className="h-4 w-4" strokeWidth={1.5} />
                  {item.name}
                </Link>
              );
            })}
          </nav>
        </div>

        {/* User info */}
        <div className="flex items-center gap-4">
          {/* Location sharing toggle */}
          <LocationToggle />

          <div className="flex items-center gap-3">
            <div className="flex h-8 w-8 items-center justify-center rounded-md bg-muted text-sm font-medium">
              {user?.first_name?.[0]?.toUpperCase() || "U"}
            </div>
            <div className="flex flex-col">
              <span className="text-sm font-medium text-foreground">
                {user?.first_name} {user?.last_name}
              </span>
              <span className="text-xs text-muted-foreground">
                {user?.role}
              </span>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="rounded-md p-2 text-muted-foreground hover:bg-muted hover:text-foreground"
            title="Logout"
          >
            <LogOut className="h-4 w-4" />
          </button>
        </div>
      </header>

      {/* Main content */}
      <main>
        <div className="min-h-[calc(100vh-4rem)]">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
